<template>
  <v-container id="licensePlate" fluid tag="section">
    <v-row v-if="inferenceCameraItem.camera != undefined">
      <v-col cols="12" class="display-3">
        {{ $t("camera") }} {{ $t("name") }} :
        {{ inferenceCameraItem.camera.camera_name }}
      </v-col>

      <v-col cols="12" class="display-1">
        {{ $t("camera") }} {{ $t("id") }} :
        {{ inferenceCameraItem.camera.camera_id }}
      </v-col>

      <v-col cols="1">
        <v-dialog width="1280">
          <template v-slot:activator="{ on, attrs }">
            <v-col
              v-bind="attrs"
              v-on="on"
              @click="openSnapshot(inferenceCameraItem)"
            >
              {{ $t("snapshot") }} <v-icon>mdi-image</v-icon>
            </v-col>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar dense color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark text @click="dialog.value = false">
                    {{ $t("close") }}
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <GuardianSnapshot
                      :image="snapshot.data"
                      :fences="inferenceCameraItem.fences"
                    ></GuardianSnapshot>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </template>
        </v-dialog>
      </v-col>

      <v-col cols="1">
        <v-dialog width="1280">
          <template v-slot:activator="{ on, attrs }">
            <v-col v-bind="attrs" v-on="on">
              {{ $t("stream") }} <v-icon>mdi-video</v-icon>
            </v-col>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar dense color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark text @click="dialog.value = false">
                    {{ $t("close") }}
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>

              <v-list>
                <v-list-item>
                  <v-list-item-content>
                    <v-img :src="stream" contain></v-img>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-list
          color="#EEEEEE"
          rounded
          style="max-height: 500px"
          class="overflow-y-auto"
        >
          <v-list-item-title class="text-h3">
            <v-row>
              <v-col align-self="center">
                {{ $t("licensePlate") }}
              </v-col>

              <v-col>
                <v-switch
                  v-model="isFixedLatest"
                  :label="$t('fixed_latest')"
                ></v-switch>
              </v-col>
            </v-row>
          </v-list-item-title>

          <v-list-item-group
            color="primary"
            v-model="selected_licensePlate_index"
          >
            <v-list-item
              v-if="licensePlateItems != null && licensePlateItems.length == 0"
            >
              <v-col class="display-3">{{ $t("no-data-hint") }}</v-col>
            </v-list-item>

            <v-list-item
              v-else
              v-for="(licensePlateItem, idx) in licensePlateItems"
              :key="idx"
              @click="selectLicensePlate(licensePlateItem)"
            >
              <v-list-item-icon>
                <v-icon v-text="licensePlateItem.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-row>
                  <v-col cols="8">
                    <GuardianSnapshot
                      :image="
                        'data:image/png;base64,' + licensePlateItem.snapshot
                      "
                      :fences="licensePlateItem.fences"
                      :objects="licensePlateItem.license_plates"
                      :max-height="300"
                      :max-width="300"
                    ></GuardianSnapshot>
                  </v-col>

                  <v-col cols="4">
                    <v-col cols="12">
                      {{ translateTime(licensePlateItem.timestamp) }}
                    </v-col>

                    <v-col cols="12">
                      <v-row
                        v-for="(
                          licensePlate, idx
                        ) in licensePlateItem.license_plates.slice(0, 3)"
                        :key="idx"
                      >
                        {{ licensePlate.number }}
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>

      <v-col cols="8">
        <v-row>
          <LicensePlateItem
            v-if="selected_licensePlate != null"
            :licensePlates="selected_licensePlate"
          ></LicensePlateItem>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LicensePlateItem from "@/components/recognition/LicensePlateItem.vue";
import GuardianSnapshot from "@/components/guardian/GuardianSnapshot";
import { getSnapshot, getStream } from "@/endpoint/camera";
import { getInferenceCameras } from "@/endpoint/inferenceCamera";
import { getLicensePlates } from "@/endpoint/licensePlate";
import { random, translateTime } from "@/plugins/util";

export default {
  name: "licensePlate",
  components: { LicensePlateItem, GuardianSnapshot },
  data() {
    return {
      isFixedLatest: false,
      timerId: null,
      selected_licensePlate_index: null,
      selected_licensePlate: null,
      snapshot: null,
      stream: null,
      inferenceCameraItem: {},
      inferenceCameraItems: [],
      licensePlateItems: null,
    };
  },
  created() {
    let infereceCameraUuid = this.$route.params.uuid;
    if (infereceCameraUuid == undefined) {
      this.redirectCameraPage();
      return;
    }

    this.init(this);
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  methods: {
    random: random,
    translateTime: translateTime,
    async init(scope) {
      let infereceCameraUuid = this.$route.params.uuid;

      scope.inferenceCameraItems = await getInferenceCameras();

      scope.inferenceCameraItem = scope.inferenceCameraItems.find(function (
        item
      ) {
        return item._id == infereceCameraUuid;
      });

      scope.licensePlateItems = await getLicensePlates(
        [],
        [scope.inferenceCameraItem.camera.camera_id]
      );

      scope.licensePlateItems.forEach((item) => {
        item.license_plates.forEach((plate) => {
          if (!scope.$store.state.withDash) {
            plate.number = plate.number.replace("-", "");
          }
        });
      });

      scope.snapshot = await getSnapshot(
        scope.inferenceCameraItem.camera.camera_id
      );

      scope.stream = await getStream(
        scope.inferenceCameraItem.camera.camera_id
      );

      scope.timerId = window.setInterval(async function () {
        scope.licensePlateItems = await getLicensePlates(
          [],
          [scope.inferenceCameraItem.camera.camera_id]
        );

        scope.licensePlateItems.forEach((item) => {
          item.license_plates.forEach((plate) => {
            if (!scope.$store.state.withDash) {
              plate.number = plate.number.replace("-", "");
            }
          });
        });

        if (scope.isFixedLatest) {
          scope.selected_licensePlate_index = 0;
          scope.selected_licensePlate = scope.licensePlateItems[0];
        }
      }, 1000);

      return scope;
    },
    selectLicensePlate(item) {
      this.selected_licensePlate = item;
    },
    openSnapshot(inference_camera) {
      (async () => {
        this.snapshot = await getSnapshot(inference_camera.camera.camera_id);
      })();
    },
    openStream(inference_camera) {
      (async () => {
        this.stream = await getStream(inference_camera.camera.camera_id);
      })();
    },
    redirectCameraPage() {
      this.$router.push({
        name: "camera",
        query: {
          type: "licensePlate",
        },
      });
    },
  },
};
</script>
